

































































import { Component, Vue, Prop } from "vue-property-decorator";
import Card from "@/components/default/Card.vue";
import {
  IMailTemplateDto,
  MailFichesZipCommand,
  MailTemplateType,
  MailTemplatesClient,
  ProcessZipCommand,
  ProjectsClient,
} from "@/data/web-api-client";
import DataSource from "devextreme/data/data_source";
import dxCustomStore from "devextreme/data/custom_store";
import Datagrid from "@/components/default/Datagrid.vue";
import projectsRepository from "@/services/projectsRepository";
import moment from "moment";
import MailPopup from "@/components/default/MailPopup.vue";
import notificationService from "@/services/notificationService";

@Component({
  components: {
    Card,
    Datagrid,
    MailPopup,
  },
})
export default class ProjectFiches extends Vue {
  @Prop({ required: true })
  project!: any;

  @Prop({ required: false, default: false })
  public disabled!: boolean;

  private projectClient: ProjectsClient = new ProjectsClient(
    undefined,
    this.$axios
  );

  fichesAvailable = false;
  private mailTemplatesClient: MailTemplatesClient = new MailTemplatesClient(undefined, this.$axios);

  fichesMailTemplate: TypeOrNull<IMailTemplateDto> = null;
  mailTemplateTypeEnum = MailTemplateType;

  async created() {
    const fichesTemplates = await this.mailTemplatesClient.getAll(MailTemplateType.ProjectFiches);

    if (fichesTemplates.length > 0) {
      this.fichesMailTemplate = fichesTemplates[0];
    }
  }

  get getFichesZip() {
    this.project["mailContacts"] = [];
    this.project.contacts.forEach((contact: { contact: { email: any; displayName: any; }; }) => {
      this.project["mailContacts"].push({
        email: contact.contact.email,
        displayName: contact.contact.displayName,
      });
    });
    const self = this;
    return new DataSource({
      store: new dxCustomStore({
        key: "key",
        load: async (loadOptions) => {
          const result = await projectsRepository.getZipData(
            loadOptions,
            self.project.id
          );
          self.fichesAvailable = result.data.data.length > 0 ? true : false;
          return {
            data: result.data.data,
            totalCount: result.data.totalCount,
          };
        },
      }),
      paginate: false,
    });
  }

  get columns() {
    return [
      {
        dataField: "name",
        caption: "Name",
      },
    ];
  }

  async generateFichesZip() {
    notificationService.showNotification('Generatie gestart op de achtergrond', 'info');
    await new ProjectsClient(undefined, this.$axios)
      .processZip(new ProcessZipCommand({ projectId: this.project.id }))
      .then(() => {
        (
          (this.$refs.grid as Datagrid).$refs.fichesTable as any
        ).instance.refresh();
      });
    notificationService.showSuccessMessage('Generatie voltooid');
    this.project.lastGeneratedFichesZip = new Date();
  }

  sendFichesZip() {
    const mailPopup = this.$refs.MailPopup as MailPopup;

    mailPopup.open();
  }

  convertDate(item: Date) {
    return moment(item).format("DD/MM/YYYY HH:mm");
  }

  async send(data: any) {
    data.content = data
      .content!.replaceAll("<p>", "<div>")
      .replaceAll("</p>", "</div>");
    await new ProjectsClient(undefined, this.$axios).sendZipData(
      new MailFichesZipCommand({
        projectId: this.project.id,
        to: data.to,
        cc: data.cc,
        from: data.from,
        subject: data.subject,
        content: data.content,
      })
    );
    notificationService.showSuccessMessage("Mail verstuurd");
    this.project.lastFichesZipSent = new Date();
  }
}
